/* eslint-disable @typescript-eslint/no-unused-expressions */
import * as React from "react";
import { Controller } from 'react-hook-form';
import { IInputText } from '../types/dataForm/types';
import { TextField } from '@mui/material';

export interface IInputCurrency extends IInputText {
  mask?: string;
}

export default function InputCurrency({ name, form, mb, label, readonly }: IInputCurrency) {
  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          disabled={readonly}
          type="text"
          sx={{ mb }}
          helperText={error ? error.message : null}
          error={!!error}
          value={value}
          label={label}
          onChange={(e) => {
            Number.isNaN(parseFloat(e.target.value)) ? 0 : parseFloat(e.target.value);
            const output = parseInt(e.target.value, 10);
            const val = isNaN(output) ? 0 : new Intl.NumberFormat('tr').format(output);
            return onChange(val);
          }}
        />
      )}
    />
  );
}
